import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import {
  Badge,
  Button,
  Card,
  CardBody,
  CardSubtitle,
  CardTitle,
  Col,
  Container,
  Row,
} from "reactstrap";
import nexteatsImg from "../../src/assets/img/nexteatsImg.png";
import {
  getAllRestaurantList,
  getRestaurantsAction,
} from "../store/actions/restaurantsAction";
import { addCartDetails, clearCartAction } from "../store/actions/cartAction";
import RestaurantLoader from "../utils/RestaurantLoader";

const RestaurantCard = ({ searchValue }) => {
  const [restaurants, setRestaurants] = useState([]);
  const dispatch = useDispatch();
  const history = useHistory();
  const { allRestaurants, fetchLoader } = useSelector(
    (state) => state.restaurants
  );
  const [loader, setLoader] = useState(null);
  const isMountedRef = useRef(true);
  const timeoutRef = useRef(null);

  // Cleanup function to prevent memory leaks
  useEffect(() => {
    return () => {
      isMountedRef.current = false;
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  const hasValidTiming = (restaurant) => {
    return restaurant?.storeTiming?.some(
      (timing) => timing.startTime && timing.endTime
    );
  };

  const handleCardClick = (id) => {
    setLoader(id);
    dispatch(clearCartAction());
    dispatch(addCartDetails({ restaurantId: id }));
    localStorage.setItem("restaurantId", id);
    dispatch(getRestaurantsAction(id));
    
    // Clear any existing timeout
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    
    timeoutRef.current = setTimeout(() => {
      if (isMountedRef.current) {
        setLoader(null);
        history.push("/order-options");
      }
    }, 1000);
  };

  useEffect(() => {
    dispatch(getAllRestaurantList());
  }, [dispatch]);

  useEffect(() => {
    if (allRestaurants?.length > 0) {
      setRestaurants(allRestaurants);
    }
  }, [allRestaurants]);

  useEffect(() => {
    if (searchValue) {
      const filteredRestaurants = allRestaurants?.filter((restaurant) =>
        restaurant?.name?.toLowerCase().includes(searchValue.toLowerCase())
      );
      setRestaurants(filteredRestaurants);
    } else {
      setRestaurants(allRestaurants);
    }
  }, [allRestaurants, searchValue]);

  return (
    <Container className="product_details">
      <Row className="g-3">
        {fetchLoader ? (
          <Container className="py-5 d-flex justify-content-center align-items-center">
            {" "}
            <RestaurantLoader message="Fetching All Restaurants" />
          </Container>
        ) : (
          <>
            {" "}
            {restaurants?.map((restaurant) => {
              const hasNameAndLocation =
                restaurant?.name &&
                restaurant?.location &&
                hasValidTiming(restaurant);

              return (
                hasNameAndLocation && (
                  <Col
                    lg="4"
                    md="6"
                    sm="12"
                    xs="12"
                    className="mb-3"
                    key={restaurant?.id}
                  >
                    <Card
                      className="my-3 cursor-pointer w-100"
                      style={{
                        width: "100%",
                        height: "100%",
                      }}
                      onClick={() => handleCardClick(restaurant?.id)}
                    >
                      <div className="position-relative d-flex align-items-center">
                        <img
                          className="card-img-top"
                          src={restaurant?.restaurantImages?.[0] || nexteatsImg}
                          alt="Card cap"
                          style={{
                            height: "250px",
                            width: "100%",
                          }}
                        />
                      </div>
                      <CardBody>
                        <CardTitle
                          tag="h5"
                          className="pb-4 mb-0 text-capitalize"
                        >
                          {restaurant?.name}
                        </CardTitle>
                        <CardSubtitle
                          tag="h6"
                          className="mb-2 text-muted text-capitalize"
                        >
                          <span className="me-1">{restaurant?.location}</span>
                        </CardSubtitle>
                        <hr className="mx-4 mb-1" />

                        <CardTitle tag="h5" className="py-4 mb-0">
                          Availability
                        </CardTitle>
                        <div className="d-flex">
                          <Row className="px-3">
                            {restaurant?.storeTiming?.map(
                              (availableDay, idx) => {
                                if (
                                  availableDay.startTime &&
                                  availableDay.endTime
                                ) {
                                  return (
                                    <Badge
                                      key={idx}
                                      color="info"
                                      className="px-3 mr-2 py-2 cursor-pointer mb-2"
                                    >
                                      {availableDay?.day}
                                    </Badge>
                                  );
                                } else {
                                  return null;
                                }
                              }
                            )}
                          </Row>
                        </div>

                        <Button
                          color="primary"
                          className="mt-3 mx-auto border-0"
                          style={{ background: "#d70365" }}
                          disabled={loader === restaurant?.id}
                          onClick={() => handleCardClick(restaurant?.id)}
                        >
                          Visit Restaurant
                        </Button>
                      </CardBody>
                    </Card>
                  </Col>
                )
              );
            })}
          </>
        )}
      </Row>
    </Container>
  );
};

export default RestaurantCard;
